import { UserCompanyDetail, UserCompanyType } from "../../../types";

/**
 * Pick a sensible material owner so the requester usually doesn't have to make
 * this call: one candidate means there is no decision to make, and a single
 * manager is the safest default when several buyers exist. Returns "" when the
 * choice is genuinely ambiguous, which keeps the field required.
 */
export const defaultOwnerId = (buyerUsers: UserCompanyDetail[]): string => {
  if (buyerUsers.length === 1) return buyerUsers[0].id;
  const managers = buyerUsers.filter(
    (u) => u.userCompanyType === UserCompanyType.MANAGER
  );
  if (managers.length === 1) return managers[0].id;
  return "";
};
